import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';

export enum InAppComponent {
  SYNC_YOUR_CARD_FIRST_TIME = 'sync-your-card-first-time',
  LINKED_CARD_CATEGORIZE_MODAL = 'linked-card-categorize-modal',
  OVERDRAFT_ELIGIBLE_FIRST_TIME = 'overdraft-eligible-first-time',
}
export interface InAppComponentLog {
  name: InAppComponent;
  presentedCount: number;
  doNotShowAgain: boolean;
}

interface GetInAppComponentLogsProps {
  customerId: string;
}

export const useGetInAppComponentsLogs = ({ customerId }: GetInAppComponentLogsProps) =>
  useQuery(
    `useGetInAppComponentsLogs-${customerId}`,
    async () => {
      const { data } = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/inAppComponentLogs`);
      return data.inAppComponentLogs as InAppComponentLog[];
    },
    {
      refetchOnWindowFocus: false,
    },
  );
